
const HEADER_SELECTOR = ".header-spacer"
const CLASS_N_SCROLLING_UP = "scrolling-up"
const CLASS_N_SCROLLING_HEADER_HEIGHT = "scrolling-header-height"
let _headerHeight = 0
let _lastScrollTop = 0

// # on window scroll
const onWindowScroll = (e) => {
  const st = window.pageYOffset || document.documentElement.scrollTop
  // # Scrolling direction
  update(st)
}
const update = (st) => {
  if (st > _lastScrollTop) {
    // scrolling DOWN
    // always show header as of #GLO75
    document.documentElement.classList.add(CLASS_N_SCROLLING_UP)
    // document.documentElement.classList.remove(CLASS_N_SCROLLING_UP)
  } else {
    // scrolling UP
    document.documentElement.classList.add(CLASS_N_SCROLLING_UP)
  }
  // # Scrolling progress (czy jestem poza obszarem "normalnego" headera)
  if (st > _headerHeight) {
    document.documentElement.classList.add(CLASS_N_SCROLLING_HEADER_HEIGHT)
  } else {
    document.documentElement.classList.remove(CLASS_N_SCROLLING_HEADER_HEIGHT)
  }
  _lastScrollTop = st
}
// get header height
const get_HeaderHeight = () => {
  let h = 0
  const header = document.querySelector(HEADER_SELECTOR)
  if (header) {
    h = header.offsetHeight
  }
  return h
}
export const updateHeaderOnLocomotiveScroll = (st) => {
  update(st)
}
// update header height
export const updateHeaderHeight = () => {
  _headerHeight = get_HeaderHeight()
}
// INIT header scroll
export const initHeaderScroll = () => {
  updateHeaderHeight()
  // window.addEventListener("scroll", onWindowScroll)
}